var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M11.436 10.596a.183.183 0 0 0 .131-.31l-3.58-3.641a.183.183 0 0 0-.314.128v3.275a.548.548 0 0 0 .548.548z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M6.805 11.464a1.995 1.995 0 0 1-.593-1.416V5.846H2.923A2.932 2.932 0 0 0 0 8.77V19a2.923 2.923 0 0 0 2.923 2.924H9.5A2.923 2.923 0 0 0 12.423 19v-6.942H8.221a1.993 1.993 0 0 1-1.416-.594M14.798 4.75h3.215a.183.183 0 0 0 .131-.31L14.564.798a.183.183 0 0 0-.314.129v3.275a.548.548 0 0 0 .548.548"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M14.798 6.212a2.026 2.026 0 0 1-2.01-2.01V0H7.857a2.744 2.744 0 0 0-2.74 2.74v1.645h1.923a1.864 1.864 0 0 1 1.32.554l4.985 5.07c.348.353.542.83.54 1.325v6.205h2.424c1.484 0 2.692-1.23 2.692-2.74V6.211z"
  })));
};
export default SvgDocument;